// extracted by mini-css-extract-plugin
export default {"sidebarLogoCont":"Logo_sidebarLogoCont__a7sgc","sidebarLogo":"Logo_sidebarLogo__B34t8","sidebarLogoColl":"Logo_sidebarLogoColl__0446l"};